module.exports = __webpack_public_path__ + "media/images/web/home/index/bg_hero-2f9a3ad094e7ad97e281ca70c5e09c72.webp";